/***************************

    Эвентээс Premium рүү очих холбоос

    `hasSonsy` тасалбарын Sonsy тэмдгээр дарахад хэрэглэгчийг Premium
    багцын хуудас руу тухайн тасалбарын хаягтай нь илгээнэ:

        /premium?eventId=1&ticketId=4

    Duo багц худалдаж авмагц сервер тэр `ticketId`-д ваучер үүсгээд
    хэрэглэгчийг тасалбарын сайт руу (tickets.sonsy.mn) буцаана.
    Тэндээс цааш түүний `lib/voucher-link.ts` барьж авна.

    ЦОРЫН ГАНЦ ҮНЭН ЭХ СУРВАЛЖ НЬ ХАЯГ.
    Query-тэй /premium — Duo карт дээр тасалбарын тэмдэг нэмэгдэнэ.
    Query-гүй /premium — ердийн хуудас. Багцын жагсаалт хоёуланд нь
    ижил: хэрэглэгч Duo-гоос өөр багц сонгож ч болно (тэр үед ваучер
    олгогдохгүй).
    Тиймээс query-г хаягнаас АРЧИХГҮЙ (нууц утга биш) бөгөөд query-гүй
    ормогц хадгалсныг нь ЦЭВЭРЛЭНЭ: цэсээс /premium рүү орсон хүн
    хагас цагийн өмнөх тасалбарын кампанит ажилд баригдах учиргүй.

    sessionStorage нь зөвхөн ЗАМД ҮРГЭЛЖЛҮҮЛЭХ зориулалттай — /premium
    -ээс гарсны дараа (төлбөрийн хуудас, гарц руу очоод буцах г.м.)
    route state алдагдвал эндээс сэргээнэ.

***************************/

import { ticketsUrl } from "./tickets-site";

const STORE_KEY = "sonsy_premium_event";

/* Төлбөр банкны апп руу гарч ороход удаж болох тул уян хугацаа.
   Дээрх цэвэрлэгээ гол хамгаалалт нь — энэ бол зөвхөн тор. */
const TTL_MS = 2 * 60 * 60 * 1000;

// eventId, ticketId нь amsys дээр бүхэл тоо. Бусдыг хүлээж авахгүй —
// эдгээр нь цааш серверийн хаяг үүсгэхэд ордог.
const isId = (value) => /^\d+$/.test(String(value === null || value === undefined ? "" : value));

/** Хадгалагдсан эвентийн хам сурвалж (байхгүй/хугацаа нь дууссан бол null). */
export const readPremiumEventLink = () => {
  try {
    const raw = window.sessionStorage.getItem(STORE_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    if (!saved || !isId(saved.eventId) || !isId(saved.ticketId)) return null;
    if (Date.now() - saved.savedAt > TTL_MS) {
      window.sessionStorage.removeItem(STORE_KEY);
      return null;
    }
    return { eventId: saved.eventId, ticketId: saved.ticketId };
  } catch (err) {
    return null;
  }
};

/** Ваучер гарт орсны дараа (эсвэл хэрэглэгч эрхгүй нь тогтоогдоход) цэвэрлэнэ. */
export const clearPremiumEventLink = () => {
  try {
    window.sessionStorage.removeItem(STORE_KEY);
  } catch (err) {
    /* noop */
  }
};

/**
 * /premium хуудсын хаягаас эвентийн хам сурвалжийг тогтооно.
 *
 * Query байвал — хадгална. Query БАЙХГҮЙ бол хэрэглэгч энэ урсгалд
 * байхаа больсон гэсэн үг тул хадгалсныг арчиж, null буцаана.
 *
 * @param {string} search location.search
 * @returns {{eventId: string, ticketId: string}|null}
 */
export const takePremiumEventLink = (search) => {
  const params = new URLSearchParams(search || "");
  const eventId = params.get("eventId");
  const ticketId = params.get("ticketId");

  if (!isId(eventId) || !isId(ticketId)) {
    clearPremiumEventLink();
    return null;
  }

  const value = {
    eventId: String(eventId),
    ticketId: String(ticketId),
    savedAt: Date.now(),
  };
  try {
    window.sessionStorage.setItem(STORE_KEY, JSON.stringify(value));
  } catch (err) {
    /* private mode — энэ ачаалалтад л барина */
  }

  return { eventId: value.eventId, ticketId: value.ticketId };
};

/**
 * Ваучер гарт орсны дараа очих тасалбарын БҮТЭН хаяг.
 *
 * Тасалбарын сайт тусдаа домэйн дээр тул харьцангуй зам болохгүй.
 * Утасгүй (и-мэйлээр бүртгүүлсэн) хэрэглэгчид SMS очдоггүй тул кодыг
 * гартаа авах ЦОРЫН ГАНЦ зам нь энэ хаяг болно.
 */
export const eventVoucherUrl = ({ eventId, ticketId, voucherCode }) =>
  ticketsUrl(
    `/${eventId}?voucherCode=${encodeURIComponent(voucherCode)}&ticketId=${ticketId}`,
  );
